<template>
  <div id="accountInformationOfRegular">
    <div class="Grid0E42B3B8">
      <div class="GridE4AB7BC7" :style="backImg">
        <div class="Grid247370F8">
          <span :text="'定期存款賬號8000562214'">{{proInfoDetails.prodName}}{{proInfoDetails.baseAcctNo}}</span>
        </div>
        <div class="GridEEE6A996">
<!--          <span :text="'2,048.99'" class="span1">{{proInfoDetails.intTotal}}</span>-->
          <span :text="'2,048.99'" class="span1">{{$commafy((Number(proInfoDetails.intTotal) + Number(proInfoDetails.balance)).toString())}}</span>
          <span :text="'预计到期金额（MOP）'" class="span2">{{$t('label.label59')}}（{{proInfoDetails.ccy}}）</span>
        </div>
        <div class="Grid3C3FDCD9">
          <div class="GridF7958DDF">
            <span :text="'期限'" class="spanUp">{{$t('label.label65')}}</span>
            <span :text="'6个月'" class="spanDown">{{$setDepositTerm(proInfoDetails.depositTerm)}}</span>
          </div>
          <div class="GridF7958DDF">
            <span :text="'期限'" class="spanUp">{{$t('label.label66')}}</span>
            <span :text="'6个月'" class="spanDown">{{proInfoDetails.intRate}}%</span>
          </div>
        </div>
      </div>
    </div>
    <div class="GridC4D2B1DF">
      <md-field-item
        :title="$t('label.label67')"
        :content="proInfoDetails.ccy"
        :solid="true"
        :align="'right'"
      />
      <md-field-item
        :title="$t('label.label68')"
        :content="proInfoDetails.buyBaseAcctNo"
        :solid="true"
        :align="'right'"
      />
      <md-field-item
        :title="$t('label.label69')"
        :content="proInfoDetails.withdrawBaseAcctNo"
        :solid="true"
        :align="'right'"
      />
      <md-field-item
        :title="$t('label.label70')"
        :content="proInfoDetails.depositTerm + '-' + $setDepositTerm(proInfoDetails.depositTerm)"
        :solid="true"
        :align="'right'"
      />
      <md-field-item
        :title="$t('label.label71')"
        :content="proInfoDetails.intRate + '%'"
        :solid="true"
        :align="'right'"
      />
      <p class="annotation">
        <span class="spanStar">*</span>
        <span class="spanArea">{{$t('label.label79')}}</span>
      </p>
    </div>
    <div class="Grid6FCC6A24">
      <md-button
        :text="'支取'"
        :type="'primary'"
        :round="true"
        @click="comfirm"
        >
        {{$t('btn.btn3')}}
      </md-button>
    </div>
  </div>
</template>
<script>
import { FieldItem, Button } from '@gidc/mobile'
import backImg from '../../assets/images/background_a.png'
import { mapGetters } from 'vuex'
export default {
  name: 'accountInformationOfRegular',
  components: {
    [FieldItem.name]: FieldItem,
    [Button.name]: Button
  },
  computed: {
    ...mapGetters([
      'proInfoDetails'
    ])
  },
  data () {
    return {
      backImg: {
        backgroundImage: 'url(' + backImg + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      }
    }
  },
  methods: {
    comfirm () {
      this.$router.push({ name: 'withdrawEntryOfCurrent' })
    }
  }
}
</script>
<style lang="stylus">
  #accountInformationOfRegular{
    .GridC4D2B1DF{
      .md-field-item{
        .md-field-item-content{
          padding 0 .3rem
          height .92rem
          .md-field-item-title{
            font-size .28rem
            text-align left
            font-weight: 400;
            height: .4rem;
            line-height: .4rem;
            white-space nowrap
          }
          .md-field-item-control{
            color: #666666;
            line-height: .4rem;
            height: .4rem;
            font-size: .28rem;
            font-weight: 400;
          }
        }
      }
    }
  }
</style>
<style lang="stylus" scoped>
  #accountInformationOfRegular{
    .Grid0E42B3B8{
      padding .2rem .3rem .45rem
      .GridE4AB7BC7{
        position relative
        width 100%
        height 3.5rem
        background-color rgb(62,140,247)
        border-radius .12rem
        .Grid247370F8{
          position: absolute
          top: 0
          left 0
          font-size: .28rem
          color: white
          background: #5CA0FF
          border-radius: .04rem 2rem 2rem .04rem
          padding 0 0.2rem
          height: .48rem
          line-height: .48rem
          text-align center
        }
        .GridEEE6A996{
          display flex
          flex-direction column
          width 100%
          height 2.58rem
          justify-content center
          align-items center
          .span1{
            display inline-block
            font-size .64rem
            color: white
            font-weight bold
            line-height .74rem
            height .74rem
          }
          .span2{
            display inline-block
            font-size .24rem
            color: white
            font-weight normal
            line-height .33rem
            height .33rem
          }
        }
        .Grid3C3FDCD9{
          display flex
          flex-direction row
          height .92rem
          border-radius .08rem
          .GridF7958DDF{
            display flex
            flex-direction column
            width 100%
            justify-content center
            align-items center
            background-size 100%
            .spanUp{
              font-size .2rem
              height .28rem
              color #FFFFFF
              line-height .28rem
              font-weight 400
            }
            .spanDown{
              height .4rem
              font-size .28rem
              line-height .4rem
              color #FFFFFF
              font-weight 600
            }
          }
          .GridF7958DDF:first-child::after{
            content ''
            height .54rem
            width 0
            border .02rem solid #7EB5FF
            position absolute
            left 50%
          }
        }
      }
    }
    .GridC4D2B1DF{
      .annotation{
        position relative
        height .33rem
        padding .25rem .15rem .03rem .3rem
        .spanStar{
          position absolute
          font-size .24rem
          left -.15rem
          font-weight 400
          color #999999
          line-height .33rem
          height .33rem
          left: .15rem;
        }
        .spanArea{
          height .33rem
          float left
          font-size .24rem
          font-weight 400
          color #999999
          line-height .33rem
        }
      }
    }
    .Grid6FCC6A24{
      padding .5rem .3rem .3rem
    }
  }
</style>
